import createReducer from 'Lib/createReducer';

export const SAVE_NOTES = 'SAVE_NOTES';


const initialState = [{
  id: '',
  text: '',
  cfi: '',
  lastModified: '',
  autoSaveNoteText: ''
}];

const actionHandlers = {
  [SAVE_NOTES]: (state, action) => {
    return [ ...action.data ];
  }
};


export default createReducer(initialState, actionHandlers);
